import { Button, Icon, Popconfirm, Tooltip } from 'antd';
import React from 'react';
import { copyArr, Format, funStrCheck, getType, uuid, uuidDate } from 'rt-sd-common/sgiCommon/sgiCommon';
import { sgiLogger } from 'rt-sd-common/sgiCommon/sgiLogger';
import { Resource } from 'rt-sd-common/sgiFactory/Resource';
import { StandardCode } from 'rt-sd-common/sgiFactory/StandardCode';
import { SgiEventHandler } from './SgiEventHandler';
import SgiTableEditorCell from './SgiTableEditorCell';
import { getConstByKey, testReactVsn, numStrAddPx } from './sgiBaseComp/SgiCommon';

const SgiTableCommon = {
	/**
     * 如果是分批 给表格设置分批函数
     * @param {*} batchFun 
     */
	setBatchInfo(path, data, callback, reqType, flag) {
		this.state.batchInfo = {
			batchFun: callback,
			path: path,
			data: data,
			reqType: reqType,
			flag: flag
		};
		this.state.pagination.total = 0;//重置条件需重新查询总数
	},

	callBatch(path, data, reqType, flag, params, filters, sorter) {
		if (!path) {
			return;
		}

		//wzhe 2020-3-10
		//为满足 新的要求  path增加对象模式 从中解析出url地址和接口id
		let url;
		let siGuid;
		if (path.constructor === Object) {
			url = path.siUrl;
			siGuid = path.rlsGuid;
		} else {
			url = path;
		}

		let request = { head: tool.getLoginInfo ? tool.getLoginInfo() : {} };
		//wzhe 2020-3-10
		//为满足 新的要求  path增加对象模式 从中解析出url地址和接口id
		request.head.serviceId = siGuid;
		// if (!request.head) request.head = {};

		if (params.pageSize) {
			request.head.pageSize = parseInt(params.pageSize);
		} else {
			request.head.pageSize = 10;
		}
		if (params.current) {
			request.head.offset = params.current;
		} else {
			request.head.offset = 1;
		}
		// sortBasis放排序属性名、sort放排序方式（ASC/DESC）
		if (sorter && sorter.order) {
			request.head.sortBasis = sorter.field;
			request.head.sort = (sorter.order === "descend") ? "DESC" : "ASC";
		}

		// 是否查总数
		const totalFlg = (this.state.pagination.total > 0);
		if (!totalFlg) {
			request.head.queryTotal = "1";
		}

		if (data) {
			request.body = data;
		}

		request = tool.jsonToStr(request);

		let response = { head: {}, body: {} };
		let sucfunc = function (res) {
			response = res;

			//session超时校验
			if (response && response.head && (response.head.code == '0405' || response.head.code == '0401')) {
				//失效 重新登录
				if (tool && tool.logout) {
					// message.warning('登录超时，请重新登录');
					tool.popMessage("登录超时，请重新登录", "warning");
					tool.logout();
				}
				return;
			}

			if (this.state.batchInfo.batchFun) {
				this.state.batchInfo.batchFun(res);

				if (!response.head) response.head = {};
				// let pageCount = response.head.pageCount;
				let recordCount = response.head.recordCount;

				if (!totalFlg) this.state.pagination.total = response.head.pageCount;
				this.setState({ loading: false });
			}
		};
		let failfunc = function (xhr, textStatus, errorThrown) {
			tool.sgiLogger.log("状态码" + xhr.status + " - " + xhr.readyState + ",错误信息" + textStatus);
			response.head.code = xhr.status;
			response.head.msg = textStatus
			if (this.state.batchInfo.batchFun) {
				this.state.batchInfo.batchFun(response);
			}
		}
		// let url = path;

		let header = tool.getHeaderInfo ? tool.getHeaderInfo() : {};
		if (!reqType) {
			reqType = 'post';
			header['Content-Type'] = "application/json; charset=utf-8";
		}
		//wzhe 2020-3-10
		//为满足 新的要求  path增加对象模式 从中解析出url地址和接口id
		header.serviceId = siGuid;

		sgiClient.restcall(url, reqType, request, header, flag, sucfunc.bind(this), failfunc.bind(this));

		return response;
	},

    /**
     * 分批从这里触发
     * @param {*} current 
     */
	batchSelect(current, filters, sorter) {
		if (current) this.state.pagination.current = current;
		if (this.state.batchInfo.batchFun) {
			this.setState({ loading: true });
			this.callBatch(this.state.batchInfo.path, this.state.batchInfo.data,
				this.state.batchInfo.reqType, this.state.batchInfo.flag, { ...this.state.pagination },
				filters, sorter);
			// this.state.batchFun({ ...this.state.pagination }, this.batchCallBack.bind(this));
		}
	},

    /**
     * 分批的回调函数，刷新页面
     * @param {*} total 
     * @param {*} data 
     */
	batchCallBack(total, data) {
		this.state.pagination.total = total;
		this.state.dataSource = data;
		this.setState({ loading: false });
	},

    /**
     * 表格的分页触发  刷新事件
     * @param {*} pagination 
     * @param {*} filters 
     * @param {*} sorter 
     */
	tableOnChange(pagination, filters, sorter) {
		if (this.state.batchInfo.batchFun) {
			this.batchSelect(pagination.current, filters, sorter);
		}
	},

	crtClmOptDnd(element, record, index) {
		let { btnName, btnIcon, optType, iCLsn, btnTip, isPopconfirm, PopconfirmText, customProps } = element;
		let clickLsn;
		let clickLsnCover;
		if (!customProps) customProps = {};
		if (!customProps.style) customProps.style = {};
		if (!customProps.style.margin) customProps.style.margin = "0px 10px 0px 0px";
		// customProps.style.height = "22px";
		let optProp = { ...customProps };
		let onClick;
		if (iCLsn) {
			clickLsn = new Function("module", "objFct", "record", "index", iCLsn);
			clickLsnCover = function (module, objFct, record, index) {
				tool.sgiLogger.log('表格按钮点击事件');
				clickLsn(module, objFct, record, index);
			}
			onClick = clickLsnCover.bind(this, this, this.props.objFct, record, index);
		}
		if (!isPopconfirm) {  //显示气泡确认框的是时候  事件转移给弹出框
			optProp.onClick = onClick;
		}
		let rtnOptInfo;
		if (!optType || optType == 'btn') {
			rtnOptInfo =
				<Tooltip title={btnTip} placement={'right'} mouseEnterDelay={1}><Button {...optProp} icon={btnIcon}>
					{btnName}
				</Button>
				</Tooltip>
		} else if (optType == 'href') {
			rtnOptInfo = <Tooltip title={btnTip} placement={'right'} mouseEnterDelay={1}><a {...optProp}>
				{btnName}
				{btnIcon ? <Icon type={btnIcon} style={{ fontSize: 16, color: '#08c' }} /> : null}
			</a>
			</Tooltip>
		}
		if (isPopconfirm) {
			return <Popconfirm title={PopconfirmText} onConfirm={onClick}>
				{rtnOptInfo}
			</Popconfirm>
		}
		return rtnOptInfo;
	},

    /**
     * 添加表格列
     * @param {*} moduleDesc
     * @param {*} columns
     */
	crtClmHeadDnd(moduleDesc, dnd_columns, columns, expandedColumns, objFct, type) {

		// 自定义列描述优先
		const cstmClmn = moduleDesc.cstmClmn;
		if (cstmClmn) {
			let $cstmClmn;
			try {
				$cstmClmn = new Function("module", "objFct", "data", cstmClmn);
			} catch (error) {
				sgiLogger.eventErr(error);
			}
			if ($cstmClmn) {
				this.state.cstmClmn = $cstmClmn;
			}
			this.state.cstmClmnFlg = true;
			return;
		}

		if (dnd_columns && dnd_columns.length > 0) {
			//拖拽的时候  拷贝一份数据，导致篡改了，拖拽的数组
			if (type == 'dnd') {
				dnd_columns = copyArr(dnd_columns, true);
			}
			dnd_columns.forEach(element => {
				//列名key为title，但存储时采用te\teid形式，这里统一转换
				element.title = Resource.getTRByPrm(element).te || element.title;

				// 优先--用户自定义渲染组件
				let cstmRender = element.cstmRender;
				let $cstmRender;
				if (funStrCheck(cstmRender)) {
					try {
						$cstmRender = new Function("text", "record", "index", "objFct", "pagination", cstmRender);
					} catch (error) {
						sgiLogger.eventErr(error);
					}
					let cstmCtl;
					if ($cstmRender) {
						cstmCtl =
							element.render = (text, record, index) => {
								return $cstmRender(text, record, index, objFct, this.state.pagination);
							}
						columns.push(element);
						return;//foreach的continue;
					}
				}

				// 用户自定义显示样式
				let befRender = element.befRender;
				let $befRender;
				if (befRender) {
					try {
						$befRender = new Function("text", "record", "index", "objFct", befRender);
					} catch (error) {
						sgiLogger.eventErr(error);
					}
				}

				//扩展列不在这里展示
				if (element.mdType == 'expanded') {
					expandedColumns.push(element);
					return;
				}

				if (element.clmType == 'optGroup') {
					let { children } = element;
					if (!children || children.length < 1) {
						return;
					}
					element.render = (text, record, index) => {
						let optList = [];
						children.forEach(sonElement => {
							// 优先--用户自定义渲染组件
							let sCstmRender = sonElement.cstmRender;
							let $sCstmRender;
							if (funStrCheck(sCstmRender)) {
								try {
									$sCstmRender = new Function("text", "record", "index", "objFct", sCstmRender);
								} catch (error) {
									sgiLogger.eventErr(error);
								}
								let cstmCtl;
								if ($sCstmRender) cstmCtl = $sCstmRender(text, record, index, objFct);
								optList.push(cstmCtl);
								return;
							}
							// 其次--用户自定义显示样式
							let sBefRender = sonElement.befRender;
							let $sBefRender;
							if (sBefRender) {
								try {
									$sBefRender = new Function("text", "record", "index", "objFct", sBefRender);
								} catch (error) {
									sgiLogger.eventErr(error);
								}
							}
							let customProps;
							if ($sBefRender) customProps = $sBefRender(text, record, index, objFct);
							sonElement.customProps = customProps || {};
							optList.push(this.crtClmOptDnd(sonElement, record, index, objFct));
						})
						return (
							<span>
								{optList}
							</span>
						)
					}
					// delete element.children;//没办法进行第二次创建了，少东西
					columns.push(Object.assign({}, element, { children: undefined }));
					return;
				} else if (element.clmType == 'opt') {
					element.render = (text, record, index) => {
						let customProps;
						if ($befRender) customProps = $befRender(text, record, index, objFct);
						element.customProps = customProps || {};
						return (
							<span>
								{this.crtClmOptDnd(element, record, index, objFct)}
							</span>
						);
					}
				} else {
					let { children, mdType, scId, width } = element;

					if (moduleDesc.isEd && (!children || children.length < 1)) {
						element.render = ((edMdDesc, objFct, type, bdInst, text, record, index) => {
							return <SgiTableEditorCell
								record={record}
								moduleDesc={edMdDesc}
								tableBDInst={bdInst + '`' + index}
								objFct={objFct}
								type={type}
							/>
						}).bind(this, element, objFct, type, getConstByKey(this, moduleDesc.insName));
					} else {
						if (mdType === 'combox' && scId) {
							element.render = ((scId, text, record, index) => {
								let customProps;
								if ($befRender) customProps = $befRender(text, record, index, objFct);
								// 下拉窗列表值在标准代码中的id
								var comboBoxData = StandardCode.getSC(scId);
								if (comboBoxData && comboBoxData.length > 0) {
									var size = comboBoxData.length;
									if (!size == 0) {
										for (let i = 0; i < size; i++) {
											var item = comboBoxData[i];
											if (item.c == text) {
												if (customProps) {
													return <span {...customProps} >{item.te}</span>;
												} else {
													return item.te;
												}
											}
										}
									}
								} else {
									if (customProps) {
										return <span {...customProps} >{text}</span>;
									} else {
										return text;
									}
								}
							}).bind(this, scId)
						} else if (mdType === 'area') {//富文本
							element.render = (text, record, index) => {
								let customProps = {};
								if ($befRender) customProps = $befRender(text, record, index, objFct);
								if (!customProps) {
									customProps = { style: {} };
								}
								if (!customProps.style) {
									customProps.style = {}
								}
								customProps.style.textOverflow = 'ellipsis';
								customProps.style.whiteSpace = 'nowrap';
								customProps.style.overflow = 'hidden';
								customProps.style.width = width ? width + 'px' : '200px';
								return <div {...customProps}>{text}</div>;
							}
						} else if (mdType === 'amount') {//金额
							const dcmDgt = element.dcmDgt;
							element.render = (text, record, index) => {
								let customProps = {};
								if ($befRender) customProps = $befRender(text, record, index, objFct);
								text = Format.amount(text, dcmDgt);
								if (customProps) {
									return <span {...customProps}>{text}</span>
								}
								return text;
							}
						} else if (mdType === 'percent') {//金额
							const { num, total, dcmDgt, isPerSign } = element;
							element.render = (text, record, index) => {
								let customProps = {};
								if ($befRender) customProps = $befRender(text, record, index, objFct);
								text = Format.percent(isNaN(num) ? record[num] : num, isNaN(total) ? record[total] : total, dcmDgt, !isPerSign);
								if (customProps) {
									return <span {...customProps}>{text}</span>
								}
								return text;
							}
						} else {//普通列
							element.render = (text, record, index) => {
								let customProps;
								if ($befRender) customProps = $befRender(text, record, index, objFct);
								if (customProps || customProps == 0) { //普通列
									// var temp = document.createElement("div"); 
									// temp.innerHTML = customProps;
									return <div>{customProps}</div>;
								} else {
									return text;
								}
							}
						}
						if (children && children.length > 0) {
							let sonColumns = [];
							this.crtClmHeadDnd(moduleDesc, children, sonColumns, type, objFct);
							element.children = sonColumns; //转换一下
						}
					}
				}
				// 排序
				if (element.isSt || (moduleDesc.allSt && element.clmType === 'clm' && (!element.children || element.children.length === 0))) {
					try {
						if (this.state.batchInfo.batchFun) {
							// 分批
							element.sorter = true;
						} else {
							// 不分批
							let key = element.dataIndex;
							element.sorter = (a, b) => getType(a[key]) === "string" ? a[key].localeCompare(b[key], 'zh-CN') : (a[key] - b[key]);
						}
					} catch (error) {
						sgiLogger.error("添加排序函数失败");
						sgiLogger.eventErr(error);
					}
				}
				columns.push(element);
			});
		}
	},

    /**
     * 绑定事件
     * @param {*} moduleDesc
     * @param {*} treeProps
     */
	bindEvent(moduleDesc, tableProps, rowSelection, functions, type) {
		//拖拽模式 不生成事件
		//表格单击事件
		var iCLsn = moduleDesc.iCLsn; // 用户自定义点击事件
		if (iCLsn && type != 'dnd') {
			var $iCLsn;
			try {
				$iCLsn = new Function("module", "objFct", "record", "index", iCLsn);
			} catch (error) {
				sgiLogger.eventErr(error);
			}

			functions.onRowClick = $iCLsn;
		}
		tableProps.onRowClick = SgiEventHandler.tableClick.bind(this);

		var dbCLsn = moduleDesc.dbCLsn; // 用户自定义双击事件
		if (dbCLsn && type != 'dnd') {
			var $dbCLsn;
			try {
				$dbCLsn = new Function("module", "objFct", "record", "index", dbCLsn);
			} catch (error) {
				sgiLogger.eventErr(error);
			}
			functions.onRowDoubleClick = $dbCLsn;
		}
		tableProps.onRowDoubleClick = SgiEventHandler.itemdblclick.bind(this);

		var ckLsn = moduleDesc.ckLsn; // 用户自定义勾选事件
		if (ckLsn && type != 'dnd') {
			var $ckLsn;
			try {
				$ckLsn = new Function("module", "objFct", "selectType", "record", "selected", "selectedRows", ckLsn);
			} catch (error) {
				sgiLogger.eventErr(error);
			}
			functions.onRowCheck = $ckLsn;
		}

		if (!rowSelection) {
			return;
		}
		//onChange(selectedRowKeys, selectedRows):已勾选key数组，已勾选行对象数组
		//手动(取消)勾选/点击(取消)全选时触发，通过方法(取消)勾选不会触发
		rowSelection.onChange = (selectedRowKeys, selectedRows) => {
			this.setState({ selectedRows: selectedRows });
			this.state.rowSelection.selectedRowKeys = selectedRowKeys;
			this.setState({ loading: false });
			tool.sgiLogger.log(`selectedRowKeys changed: ${selectedRowKeys}`);
		}
		//onSelect(record, selected, selectedRows, nativeEvent):当前操作对象，勾选状态，已勾选行对象数组，
		//手动(取消)勾选时触发，点击(取消)全选时不会触发
		rowSelection.onSelect = (record, selected, selectedRows) => {
			// this.setState({ selectedRows: selectedRows });
			tool.sgiLogger.log("table rowSelection onSelect, record:", record, "selected:", selected, "selectedRows:", selectedRows);

			// 执行自定义勾选事件
			SgiEventHandler.tableCheck.call(this, "selectRecord", record, selected, selectedRows);
		}
		//onSelectAll(selected, selectedRows, changeRows):勾选状态，已勾选行对象数组，勾选状态发生变化的对象数组（即全部数据）
		//点击(取消)全选时触发，手动一个一个勾选至(非)全选时不触发
		rowSelection.onSelectAll = (selected, selectedRows) => {
			// this.setState({ selectedRows: selectedRows });
			tool.sgiLogger.log("table rowSelection onSelectAll, selected:", selected, "selectedRows:", selectedRows);

			// 执行自定义勾选事件
			SgiEventHandler.tableCheck.call(this, "selectAll", null, selected, selectedRows);
		}
	},

	/**
     * 创建表格的选择模式
     * @param {TD} 表格描述
     * 创建表格选择模式使用表格以下属性
     * SltMdTyp：表格选择模式（0:选择行、1:选择格、2:带CheckBox的选择行）
     * sltMd：表格的行选择模式，0 单选 1 ：点击行进行多选  2：多选 按住ctrl或者shift多选
     */
	crtTblSltModel(moduleDesc) {
		let rowSelection = {};
		//单选多选
		var rowSMd = moduleDesc.rowSMd;
		if (!rowSMd || rowSMd == "9") {

		} else if (!rowSMd || rowSMd == "0") {
			this.state.rowSelection = {};
			this.state.rowSelection.type = 'radio';//放弃不放
			this.state.rowSelection.columnWidth = '35px';
		} else if (rowSMd == 1 || rowSMd == 2) {
			this.state.rowSelection = {};
			this.state.rowSelection.type = 'checkbox';
			this.state.rowSelection.selectedRowKeys = [];
			this.state.rowSelection.columnWidth = '35px';
		}
	},

	setTbSelType(type) {
		let moduleDesc = this.props.moduleDesc;
		let consType = this.props.type;
		//单选多选
		var rowSMd = type;
		if (!rowSMd || rowSMd == "none") {
			this.state.rowSelection = undefined;
		} else if (rowSMd == "radio") {
			this.state.rowSelection = {};
			this.state.rowSelection.type = 'radio';//放弃不放
			this.state.rowSelection.columnWidth = '35px';
			//绑定事件
			this.bindEvent(moduleDesc, this.state.tableProps, this.state.rowSelection, this.state.functions, consType);
		} else if (rowSMd == "checkbox") {
			this.state.rowSelection = {};
			this.state.rowSelection.type = 'checkbox';
			this.state.rowSelection.selectedRowKeys = [];
			this.state.rowSelection.columnWidth = '35px';
			//绑定事件
			this.bindEvent(moduleDesc, this.state.tableProps, this.state.rowSelection, this.state.functions, consType);
		}
		this.setState({ loading: false });
	},

	showTotal(total) {
		return `总数 ${this.state.pagination.total || total}`;
	},

    /**
     * 创建表格下部翻页工具条
     * @param {*} moduleDesc
     * @param {*} tableStore
     * @param {*} ws
     * @param {*} objFct
     */
	crtPgeBbar(moduleDesc, tableStore, objFct) {
		if (moduleDesc.isPg) {//是否带翻页控件
			let pgRows = moduleDesc.pgRows;
			let pageSizeOptions = ["10", "20", "30", "40", "50", "60", "70", "80", "90", "100"];
			if (!pgRows) pgRows = 10;
			else pageSizeOptions.unshift(pgRows + "");
			let pagination = {
				total: tableStore.length,
				// current: 1,
				showSizeChanger: true,
				// showQuickJumper :true,
				size: 'small',
				pageSize: pgRows,
				showTotal: this.showTotal.bind(this),
				// simple:true,
				onShowSizeChange: (current, pageSize) => {
					this.state.pagination.pageSize = pageSize;
				},
				pageSizeOptions
			};
			this.state.pagination = pagination;
		}
	},


    /**
     * 创建表格绑定store
     * @param {*} moduleDesc
     * @param {*} objFct
     * @param {*} ClmDes
     */
	getTBData(moduleDesc, objFct) {
		//取得绑定实例名
		var insName = getConstByKey(this, moduleDesc.insName); //绑定实例名
		var tData;
		//取得绑定类名`  var tData = [];
		if (insName && objFct) {
			tData = objFct.get(insName);
		}
		if (!tData) {
			tData = [];
			if (objFct) objFct.set(insName, tData); //默认放入空数组  删除添加时，同步数据bug问题
			return tData;
		}
		// tData.forEach(element => {
		// 	if (!element._key) element._key = uuid(8)
		// })
		this._setKey(tData, moduleDesc.childrenColumnName)
		return tData;
	},

	/**
	 * 递归给_key赋值
	 * 树表结构时子节点也需设置_key,否则渲染不出来子节点
	 * childrenColumnName:子节点属性key
	 */
	_setKey(tData, childrenColumnName = "children") {
		if (!Array.isArray(tData)) return
		tData.forEach(element => {
			if (!element._key) {
				element._key = uuid(8)
			}
			if (Array.isArray(element[childrenColumnName])) {
				this._setKey(element[childrenColumnName], childrenColumnName)
			}
		})

	},

	/**
     * [刷新表格控件]
     * @param  {[type]} tableData [表格数据对象数组]
     * @return {[type]}           [description]
     */
	refreshTable(tableData) {
		if (tableData) {
			this.state.dataSource = tableData;
			if (testReactVsn(this, 16)) this.state.tableProps.key = uuidDate(6);//react16引用不变无法刷新，这里强制重新渲染

			this.state.dataSource.forEach(element => {
				if (!element._key) element._key = uuid(8)
			})

			// 如果不是分批表格，直接同步总数=表格数据总数
			if (!this.state.batchInfo.batchFun) {
				this.state.pagination.total = tableData.length;
			}

			this.setState({ loading: false });
		}
	},

	refresh() {
		this.loaded = false;
		this.setState({ loading: false });
	},

	//即时筛选
	selOnChange(attname, e, e2) {
		let value = e.target.value;
		this.state.selValues[attname] = value;
		this.onSel();
		this.setState({ loading: false });
	},

	//筛选方法
	onSel() {
		const { mat } = this.state.selValues;
		if (mat) {
			let reg = new RegExp(mat, 'gi');
			this.state.store = this.state.dataSource.filter((e, i, a) => {
				// return e.n.match(reg) || e.te.match(reg) || e.guid.match(reg);
				return this._match(e, reg);
			});
		} else {
			this.state.store = this.state.dataSource;
		}
		this._synPagination();
	},

	//遍历属性是否含有匹配值，返回boolen
	_match(e, reg) {
		let columns = this.state.columns;
		let indexs = columns.map(col => (col.dataIndex)).filter(d => d);//filter去除空值/假值
		if (this.state.contain) {//包含
			for (let i = 0; i < indexs.length; i++) {
				if (e[indexs[i]] && e[indexs[i]].toString().match(reg)) return true;//数字等值需要使用toString进行转换
			}
			return false;
		} else {//排除
			for (let i = 0; i < indexs.length; i++) {
				if (e[indexs[i]] && e[indexs[i]].toString().match(reg)) return false;//数字等值需要使用toString进行转换
			}
			return true;
		}
	},

	// 根据表格数据同步表格总数
	_synPagination() {
		let store = this.state.store || [];
		this.state.pagination.total = store.length;
	},

	// 包含/不包含筛选选项切换事件
	containOnChange(e) {
		let value = e.target.value;
		// this.state.contain = !!value;
		this.setState({ contain: !!value });
	},

	expandedRowRender(record) {
		var expandedList = [];
		this.state.expandedColumns.forEach(element => {
			// if (record[element.dataIndex]) {
			let errFlg = false;
			let value;
			try {
				value = eval(`record.${element.dataIndex}`);
			} catch (error) {
				tool.sgiLogger.log("eval获取嵌套属性失败：", error);
				errFlg = true;
			}
			expandedList.push(<p style={{ margin: 0 }}>{errFlg ? record[element.dataIndex] : value}</p>)
			// }
		});
		// tool.sgiLogger.log("expandedList:", expandedList);
		return <div>{expandedList}</div>
	},

	setLoading(loading) {
		this.setState({ loading });
	},

	handleResize(index) {
		return (e, { size }) => {
			// this.setState(({ columns }) => {
			//     const nextColumns = [...columns];
			//     nextColumns[index] = {
			//         ...nextColumns[index],
			//         width: size.width,
			//     };
			//     return { columns: nextColumns };
			// });
			this.state.columns[index].width = size.width;
			if (testReactVsn(this, 16)) {
				// react16需要更新引用
				this.state.columns = [...this.state.columns];
			}
			this.setState({});
		}
	},
};

export { SgiTableCommon };
export default SgiTableCommon;


// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiComp/SgiTableCommon.js